module["exports"] = [
  "(Persero) Tbk",
  "Tbk"
];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/company/suffix.js
// module id = 700
// module chunks = 0